module.exports = __webpack_public_path__ + "static/media/IMG_3072.afc72e2c.JPG";